<template>
  <div class="home">
    <BasicSearch/>
  </div>
</template>

<script>
// @ is an alias to /src
import BasicSearch from '@/views/BasicSearch.vue'

export default {
  name: 'Home',
  components: {
    BasicSearch
  }
}
</script>
